import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container container--animation" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "success",
  role: "alert"
}, " Вы успешно вошли! ", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "title title--h3" }, " Пожалуйста ", -1)

import { useRouter } from "vue-router";
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import BasicButton from '@/components/UI/BasicButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props) {

const { useActions, useGetters } = createNamespacedHelpers('authModule');

const router = useRouter();

const { logOut } = useActions(['logOut']);
const { getUser } = useGetters(['getUser']);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(getUser).data?.uid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, " Добро пожаловать, " + _toDisplayString(_unref(getUser).data?.displayName), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(BasicButton, {
              onClick: _withModifiers(_unref(logOut), ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Выйти ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _createVNode(BasicButton, {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push({ name: 'Login' })), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Войдите ")
              ]),
              _: 1
            }),
            _createTextVNode(" или "),
            _createVNode(BasicButton, {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push({ name: 'Register' })), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Зарегистрируйтесь ")
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}
}

})